import React from 'react';
import './lounaspaikka-banner.m.css';
import LazyEagerImage from '../lazy-eager';

const LounaspaikkaBanner = () =>
  <div styleName="lounaspaikka-banner">
        <a aria-label="Lounaspaikka" href="https://lounaspaikka.ilkkapohjalainen.fi/"  target="_blank">
          <LazyEagerImage src="/assetify/lounaspaikka.png" alt="Lounaspaikka" />
        </a>
  </div>

export {LounaspaikkaBanner}
